<template>
  <div class="bootcamp-video">
    <div v-show="isVideoLoading" class="bootcamp-video__spinner-wrapper">
      <ActionLoader />
    </div>
    <MediaDelegate
      v-bind="{
        parentType: 'bootcamp',
        content: { ...video, type: 'video' },
        userCompletionStatus: videoStatus,
      }"
      @is-loading="setIsLoading"
    />
  </div>
</template>

<script>
import MediaDelegate from '@/components/media/MediaDelegate.vue'
import ActionLoader from '@/components/shared/ActionLoader.vue'

export default {
  name: 'BootcampVideo',
  components: {
    MediaDelegate,
    ActionLoader,
  },
  props: {
    isVideoLoading: {
      type: Boolean,
      required: true,
    },
    video: {
      type: Object,
      required: true,
    },
    videoStatus: {
      type: String,
      required: true,
    },
  },
  methods: {
    setIsLoading(state) {
      this.$store.dispatch('app/setIsComponentLoading', state)
    },
  },
}
</script>

<style lang="scss">
.bootcamp-video {
  position: relative;
  background: var(--black);
  @include desktop {
    min-height: 505px;
  }
  &__spinner-wrapper {
    position: absolute;
    right: 0;
    left: 0;
    top: 0;
    text-align: center;
    margin: auto;
    height: 100%;
    width: 100%;
    z-index: 999999;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
